import React from 'react';
import { History } from 'lucide-react';
import { Panel, PanelHead } from '../aa';
import { relativeTime } from '../../pages/partner/format';
import type { ActivityEvent } from '../../types/aai';

export const BILLING_HISTORY_LIMIT = 10;

const changeLine = (event: ActivityEvent): string => {
  if (event.change?.from && event.change?.to) return `${event.change.from} to ${event.change.to}`;
  return event.entity_title || '';
};

/* Every Owner can change billing, so each change says who made it. */
export const BillingHistoryPanel: React.FC<{ events: ActivityEvent[] | null }> = ({ events }) => {
  let empty = 'No billing changes yet. Card, plan, seat, top-up and billing email changes appear here with who made them.';
  if (!events) empty = 'Billing changes could not be loaded right now. Reopen Billing to try again.';
  const rows = events || [];

  return (
    <Panel>
      <PanelHead kicker="Audit" title="Billing changes" desc="Every Owner can manage billing. Each change is recorded with who made it." />
      {rows.length === 0 && <div className="px-6 pb-6 text-[13px] text-ink-dim">{empty}</div>}
      {rows.length > 0 && (
        <ul className="m-0 list-none border-t border-line-soft p-0">
          {rows.map((event) => (
            <li key={event.id} className="flex min-h-[60px] items-center gap-3 border-b border-line-soft px-6 py-3 last:border-b-0">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-tile bg-canvas-inset text-ink-dim">
                <History size={16} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-[13.5px] font-semibold text-ink">
                  {event.label}
                  {changeLine(event) && <span className="font-normal text-ink-dim"> · {changeLine(event)}</span>}
                </span>
                <span className="block truncate text-[12px] text-ink-dim">{event.actor_email || 'Agents Anywhere'}</span>
              </span>
              <span className="shrink-0 text-[12.5px] text-ink-dim">{relativeTime(event.created_at)}</span>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
};
